/** Feste Helligkeit je Thema, wie Mockup v005 (644, Entscheid 662): Eine dunkle Hausfarbe bleibt im dunklen Thema sichtbar, jede Linie hält mindestens 3:1. */
const LIGHTNESS = { light: 0.62, dark: 0.72 };
/** Höchstens so bunt wird eine Hausfarbe im Diagramm. Eine Untergrenze gibt es nicht: Grau bleibt Grau. */
const MAX_CHROMA = 0.16;
const CHROMA_STEP = 0.002;
/** Rundungsluft der Matrizen: Ein Kanal knapp außerhalb von 0…1 zählt noch als darstellbar. */
const GAMUT_SLACK = 0.0005;
const toLinear = (c) => (c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);
const toGamma = (c) => (c <= 0.0031308 ? 12.92 * c : 1.055 * c ** (1 / 2.4) - 0.055);
/** `#RRGGBB` → OKLab (Matrizen nach Björn Ottosson, wie sie auch CSS `oklch()` nutzt). */
function hexToOklab(hex) {
    const [r, g, b] = [1, 3, 5].map((i) => toLinear(parseInt(hex.slice(i, i + 2), 16) / 255));
    const l = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b);
    const m = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b);
    const s = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
    return [0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s,
        1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s,
        0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s];
}
/** OKLCH (Farbton als Winkel im Bogenmaß) → lineares sRGB, Werte außerhalb 0…1 bleiben stehen. */
function oklchToLinear(lightness, chroma, hue) {
    const a = chroma * Math.cos(hue), b = chroma * Math.sin(hue);
    const l = (lightness + 0.3963377774 * a + 0.2158037573 * b) ** 3;
    const m = (lightness - 0.1055613458 * a - 0.0638541728 * b) ** 3;
    const s = (lightness - 0.0894841775 * a - 1.291485548 * b) ** 3;
    return [4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s,
        -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s,
        -0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s];
}
const inGamut = (rgb) => rgb.every((c) => c >= -GAMUT_SLACK && c <= 1 + GAMUT_SLACK);
const channel = (c) => Math.round(255 * toGamma(Math.min(1, Math.max(0, c))));
/**
 * Hausfarbe im Diagramm (644): Farbton aus `hex`, Helligkeit fest je Thema (`thema.farbschema` aus `--farbschema`, ohne Token hell), Buntheit
 * höchstens 0,16. Liegt das Ergebnis außerhalb des sRGB-Raums, sinkt die Buntheit schrittweise; Helligkeit und Farbton bleiben.
 */
export function hausfarbeImDiagramm(hex, thema) {
    const lightness = thema.farbschema === "dark" ? LIGHTNESS.dark : LIGHTNESS.light;
    const [, a, b] = hexToOklab(hex);
    const hue = Math.atan2(b, a);
    let chroma = Math.min(Math.hypot(a, b), MAX_CHROMA);
    let rgb = oklchToLinear(lightness, chroma, hue);
    while (!inGamut(rgb) && chroma > 0) {
        chroma = Math.max(0, chroma - CHROMA_STEP);
        rgb = oklchToLinear(lightness, chroma, hue);
    }
    return `rgb(${rgb.map(channel).join(" ")})`;
}
const TONE_KEYS = { ACCENT: "aktion", OK: "ok", WARN: "warnung", ERROR: "fehler", NEUTRAL: "aus" };
/** `ACCENT` --aktion, `OK` --ok, `WARN` --warnung, `ERROR` --fehler, `NEUTRAL` --status-aus. */
export function toneFarbe(tone, thema) {
    return thema[TONE_KEYS[tone]];
}
/** Platz 1 bis 8 der Diagrammpalette (649). */
export function paletteFarbe(platz, thema) {
    return thema.color[platz - 1];
}
//# sourceMappingURL=tileFarben.js.map